<template>
  <div>
    <group>
      <upload-file
        title="加油确认单"
        :params="{ path: '/billConfirm' }"
        v-model="params.oilVoucher"
        type="admin"
      ></upload-file>
    </group>
    <card>
      <description-list class="info-body" type="large" v-if="params.type == 2">
        <description-list-item term="预订油价">
          {{ params.discountPrice }}
        </description-list-item>
        <description-list-item term="预订加油量">
          {{ params.quantity
          }}<span style="color: #ff3600"
            >(已加{{ params.usedQuantity + params.unitName }},剩余{{
              params.remainQuantity + params.unitName
            }})</span
          >
        </description-list-item>
      </description-list>
    </card>
    <group>
      <!--            <x-input :title="title2" v-model="params.discountPrice"></x-input>-->
      <!--            <x-input :title="title3" v-model="params.quantity"></x-input>-->
      <selector
        title="加油渔船"
        direction="rtl"
        placeholder="请选择加油渔船"
        v-model="params.clientShipId"
        :options="shipList"
      ></selector>
      <selector
        title="运油车船"
        direction="rtl"
        v-model="params.shipId"
        :options="transportList"
      ></selector>
      <datetime
        placeholder="请选择时间"
        format="YYYY-MM-DD"
        v-model="params.useTime"
        title="用油时间"
      ></datetime>
      <x-textarea title="用油地址" v-model="params.address"></x-textarea>

      <x-input
        title="油品单价"
        disabled="disabled"
        v-model="params.orderItems[0].discountPrice"
      ></x-input>
      <x-input
        :title="title1"
        v-model="quantity"
        placeholder="请输入实际加油量"
      ></x-input>
      <cell title="实付金额">{{ ((total * 10) / 10).toFixed(2) }}</cell>
      <selector
        title="付款方式"
        direction="rtl"
        v-model="params.paymentMethod"
        :options="payOptions"
      ></selector>
      <x-textarea title="备注说明" v-model="remark"></x-textarea>
    </group>
    <group style="margin-bottom: 40px;"> </group>
    <div class="button-bottom-wrap" style="display: flex;">
      <button class="button-bottom" :disabled="disabled" @click="submit">
        确认上传
      </button>
    </div>
  </div>
</template>

<script>
import UploadFile from "@/components/Upload/UploaderFile";
import { addConfirmAdminOrder } from "@/api/order";
import { getAdminOrderDetail, adminOrderPaymentMethod } from "../../api/order";
// import { getAdminPayerList, getAdminClientShipList,getTransportList } from "@/api/ship";
import { getAdminClientShipList, getTransportList } from "@/api/ship";
import { adminBankActiveList } from "../../api/bank";
import {
  DescriptionList,
  DescriptionListItem
} from "@/components/DescriptionList";

export default {
  props: {
    id: {
      type: String
    }
  },
  components: { DescriptionList, DescriptionListItem, UploadFile },
  data() {
    return {
      params: {},
      remark: "",
      quantity: "",
      payOptions: [],
      shareShipList: [],
      shipList: "",
      bankList: [],
      disabled: false,
      title1: "实际加油量()",
      title2: "预定油价()",
      title3: "预定加油量()",
      transportList: []
    };
  },
  watch: {
    "params.payerClientId"(val) {
      if (!this.params.bankId) {
        this.params.bankId = "";
      }
      if (val) {
        this.fetchBankActiveList(val);
      }
    }
  },
  computed: {
    total() {
      if (
        this.params.orderItems[0].discountPrice &&
        this.params.orderItems[0].quantity
      ) {
        return this.params.orderItems[0].discountPrice * this.quantity;
      } else {
        return "";
      }
    }
  },
  created() {
    this.getAdminOrderDetail();
  },
  methods: {
    getTransportList() {
      getTransportList()
        .then(res => {
          this.transportList = res.map(x => {
            let value;
            if (x.type == 2) {
              value = x.shipCode + "(船发)";
            } else {
              value = x.shipCode + "(车发)";
            }
            return {
              key: x.id,
              value: value
            };
          });
          if (this.transportList.length > 0) {
            this.params.shipId = this.transportList[0].key;
          }
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    getAdminClientShipList() {
      getAdminClientShipList({
        clientId: this.params.clientId,
        companyId: this.params.clientCompanyId,
        type: this.params.buyerType
      })
        .then(res => {
          this.shipList = res.records.map(x => {
            return {
              key: x.id,
              value: x.shipCode
            };
          });
          // if (this.shipList.length > 0) {
          //   this.params.clientShipId = this.shipList[0].key;
          // }
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    fetchBankActiveList(clientId) {
      adminBankActiveList({ clientId: clientId, type: this.params.buyerType })
        .then(res => {
          this.bankList = res.map(x => {
            return {
              key: x.id,
              value: x.accountNumber
            };
          });
          if (this.bankList.length > 0) {
            this.params.bankId = this.bankList[0].key;
          }
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    // fetchPayerList(clientShipId, clientId) {
    //   return getAdminPayerList({
    //     shipId: clientShipId,
    //     paymentMethod: this.params.paymentMethod,
    //     clientId: clientId,
    //     type: this.params.buyerType
    //   }).then(res => {
    //     this.shareShipList = res.map(x => {
    //       return {
    //         key: x.clientId,
    //         value: x.clientName,
    //         clientId: x.clientId
    //       };
    //     });
    //     if (this.shareShipList.length > 0) {
    //       if (this.params.payerClientId) {
    //         for (let i = 0; i < this.shareShipList.length; i++) {
    //           if (this.shareShipList[i].key == this.params.payerClientId) {
    //             this.params.payerClientId = this.shareShipList[i].clientId;
    //           }
    //         }
    //       } else {
    //         this.params.payerClientId = this.shareShipList[0].key;
    //       }
    //     }
    //   });
    // },
    fetchPaymentMethod() {
      adminOrderPaymentMethod()
        .then(res => {
          this.payOptions = res.map(x => {
            return {
              key: x.value,
              value: x.name
            };
          });
          if (this.payOptions.length > 0) {
            this.params.paymentMethod = this.payOptions[0].key;
          }
        })
        .catch(err => {
          this.$showMessage(err);
        });
    },
    getAdminOrderDetail() {
      getAdminOrderDetail({ id: this.$route.params.id })
        .then(res => {
          this.title1 = "实际加油量(" + res.unitName + ")";
          this.title2 = "预定油价(元/" + res.unitName + ")";
          this.title3 = "预定加油量(" + res.unitName + ")";
          this.params = res;
          if (res.type == 1) {
            this.quantity = res.orderItems[0].quantity;
          }
          this.getAdminClientShipList();
          this.getTransportList();
          this.fetchPaymentMethod();
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    submit() {
      if (
        Number(this.params.remainQuantity) < Number(this.quantity) &&
        this.params.type == 2
      ) {
        this.$showMessage(
          "最多还剩下" +
            this.params.remainQuantity +
            this.params.unitName +
            "油可加"
        );
      } else if (
        Number(this.params.remainAmount) <
        parseFloat(this.params.orderItems[0].discountPrice * this.quantity)
      ) {
        let a = confirm("当前可用余额不足，是否继续加油");
        if (a) {
          this.disabled = true;
          this.$vux.loading.show();
          const params = {
            address: this.params.address,
            confirmVoucher: this.params.oilVoucher,
            discountPrice: this.params.discountPrice,
            orderId: this.id,
            orderItemVersion: this.params.orderItems[0].version,
            paymentMethod: this.params.paymentMethod,
            quantity: this.quantity,
            remark: this.remark,
            serialNo: new Date().getTime(),
            clientShipId: this.params.clientShipId,
            shipId: this.params.shipId,
            totalPrice: this.params.discountPrice * this.params.quantity,
            useTime: this.params.useTime
          };

          this.$validate(params)
            .then(() => {
              addConfirmAdminOrder(params)
                .then(() => {
                  this.disabled = false;
                  this.$vux.loading.hide();
                  this.$showMessage("上传成功");
                  // this.fetchOrderDetail({ id: this.id });
                  setTimeout(() => {
                    this.$router.back();
                  });
                })
                .catch(e => {
                  this.disabled = false;
                  this.$vux.loading.hide();
                  this.$showError(e);
                });
            })
            .catch(e => {
              this.disabled = false;
              this.$vux.loading.hide();
              this.$showError(e);
            });
        }
      } else {
        this.disabled = true;
        this.$vux.loading.show();
        const params = {
          address: this.params.address,
          confirmVoucher: this.params.oilVoucher,
          discountPrice: this.params.discountPrice,
          orderId: this.id,
          orderItemVersion: this.params.orderItems[0].version,
          paymentMethod: this.params.paymentMethod,
          quantity: this.quantity,
          remark: this.remark,
          serialNo: new Date().getTime(),
          clientShipId: this.params.clientShipId,
          shipId: this.params.shipId,
          totalPrice: this.params.discountPrice * this.params.quantity,
          useTime: this.params.useTime
        };

        this.$validate(params)
          .then(() => {
            addConfirmAdminOrder(params)
              .then(() => {
                this.disabled = false;
                this.$vux.loading.hide();
                this.$showMessage("上传成功");
                // this.fetchOrderDetail({ id: this.id });
                setTimeout(() => {
                  this.$router.back();
                });
              })
              .catch(e => {
                this.disabled = false;
                this.$vux.loading.hide();
                this.$showError(e);
              });
          })
          .catch(e => {
            this.disabled = false;
            this.$vux.loading.hide();
            this.$showError(e);
          });
      }
    }
  }
};
</script>

<style>
.info-body {
  overflow: hidden;
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>
